export default __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.007a43ce.ttf";